// Axios
import axios from "axios";

// Endpoints
import {
    ENDPOINTS_POST,
    ENDPOINTS_PUT,
    ENDPOINTS_GET,
    ENDPOINTS_DELETE,
} from "@/app/apis/main/address-finder/_connection/address-finder-connection-endpoints.js";

// Interceptor
import { addressFinderInterceptor } from "@/app/apis/main/address-finder/_connection/address-finder-connection-interceptors.js";

// API Instance
export const addressFinderInstance = axios.create({
    baseURL: `${process.env.VUE_APP_ADDRESS_FINDER_BASE_URL}`,
    headers: {},
    timeout: 20000, // 20 seconds
    validateStatus: (status) => {
        return status;
    },
});

// Interceptor
addressFinderInterceptor(addressFinderInstance);

// API Methods
export const ADDRESS_FINDER = {
    post(endpoint, formData) {
        return addressFinderInstance.post(endpoint, formData);
    },
    put(endpoint, formData) {
        return addressFinderInstance.put(endpoint, formData);
    },
    get(endpoint) {
        return addressFinderInstance.get(endpoint);
    },
    delete(endpoint) {
        return addressFinderInstance.delete(endpoint);
    },
};

// API Endpoints
export const ADDRESS_FINDER_ENDPOINTS = {
    ...ENDPOINTS_POST,
    ...ENDPOINTS_PUT,
    ...ENDPOINTS_GET,
    ...ENDPOINTS_DELETE,
};
